import { render, staticRenderFns } from "./Injuries.vue?vue&type=template&id=54d4dd0a&scoped=true"
import script from "./Injuries.vue?vue&type=script&lang=js"
export * from "./Injuries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d4dd0a",
  null
  
)

export default component.exports